import { defineNuxtPlugin } from 'nuxt/app'

import { createPageAccessToken } from '~/api/wikitrade-market'

/** 判断当前路径是否为行情工作台（含 i18n 前缀）。 */
const isMarketRoute = (path: string) => /(^|\/)market(?:\/|$|\?)/.test(path)

/**
 * 从 Nuxt i18n 实例读取当前语言；禁止在 afterEach 等回调里调用 useAppI18n/useI18n。
 */
const resolveLanguageCode = (nuxtApp: ReturnType<typeof useNuxtApp>) => {
  const locale = (nuxtApp.$i18n as { locale?: string | { value?: string } } | undefined)?.locale
  if (typeof locale === 'string' && locale) return locale
  if (locale && typeof locale === 'object' && typeof locale.value === 'string' && locale.value) return locale.value
  return 'en'
}

/**
 * 进入 /market 时尽早预取 WikiTrade access token。
 * createPageAccessToken 自带内存 Promise / localStorage 去重，可与页面 chunk 加载并行，缩短鉴权等待。
 */
export default defineNuxtPlugin({
  name: 'wikitrade-token-prefetch',
  setup(nuxtApp) {
    const route = useRoute()
    const router = useRouter()
    const api = useEnvApi()

    const prefetch = (path = route.path) => {
      if (!isMarketRoute(path)) return
      void createPageAccessToken(api.wikitrade, {
        languageCode: resolveLanguageCode(nuxtApp),
      }).catch(() => undefined)
    }

    prefetch()
    router.afterEach((to) => {
      prefetch(to.path)
    })
  },
})
